/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useCancellationQuote } from '../CancellationQuoteProvider';
import { useHistory } from 'react-router';
import { getPathNameForStage } from '../lib/getPathNameForStage';
import { useDetailsBooking } from 'lib/hooks';

export const useSyncUrlWithStage = () => {
  const { booking } = useDetailsBooking();
  const { error, cancellationState } = useCancellationQuote();
  const { replace, location } = useHistory();

  const pathname = getPathNameForStage(booking.id, cancellationState, error);

  useEffect(() => {
    if (pathname !== location.pathname) {
      replace(pathname);
    }
  }, [replace, pathname]);
};
